import { CombinedGraphQLErrors } from '@apollo/client'

/**
 * L'API a-t-elle répondu « introuvable » ? À distinguer d'une panne : un écran qui
 * dirait « introuvable » pour un timeout ferait croire à un compte supprimé (#242).
 */
export function isNotFoundError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false
  return error.errors.some(e => e.extensions?.code === 'NOT_FOUND' || /not found/i.test(e.message))
}
